import React from 'react';
import SignaturePad from 'signature_pad/dist/signature_pad.js';
import BasicStep from './BasicStep';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required } from '../Validation/Rules';
import SMSVerification from '../Forms/SMSVerification';
import Urls from "../../common/Urls";


const fieldValidations = [
  RuleRunner("hasCheckedGeneralCondition", "La sélection des condition générales de ventes", required),
];

const errorMessageSignaturePad = "Vous devez signer le formulaire."

export default class Validation extends BasicStep {

  constructor(props) {
    super(props);

    this.state = {
      dataIsLoaded: true,
      isFinished: false,
    };

    this.store = props.getStore();
  }

  /**
   * @return boolean false if there are some errors
   */
  checkForm() {
    let formsChecked = [];
    formsChecked[0] = this.refs["smsValidation"].checkForm();

    return !formsChecked.includes(false);
  }

  sendMail(){
    fetch(Urls.sendMail()+"?membership="+this.store.membership, {
      method: 'GET',
      mode: "cors",
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
        .then(response => {
          if (response.ok) {
            if (response.status == 200) {
              this.setState({
                isFinished: true,
                dataIsLoaded: true,
              });
            } else {
              this.setState({
                dataIsLoaded: true,
                errorMsg: response.message
              });
            }
          } else {
            this.setState({
              dataIsLoaded: true,
              errorMsg: "Error on response -> " + JSON.stringify(response)
            })
          }
        })
        .catch((error) => {
          this.setState({
            dataIsLoaded: true,
            errorMsg: JSON.stringify(error)
          })
        });

    this.setState({
      dataIsLoaded: false
    });
  }

  renderFinishedView() {
    return (
        <div className="endstep">
          <h2 className="text-center">Merci d'avoir adhéré au programme !</h2>
        </div>
    );
  }

  renderLoadingView() {
    return (
        <p className="endstep">Envoie des données sur le serveur...</p>
    );
  }

  render() {
    if (!this.state.dataIsLoaded) {
      return this.renderLoadingView();
    }
    else if (this.state.isFinished) {
      return this.renderFinishedView();
    }
    else {
      return (
          <div className="step step6">
            <form className="form">
              <SMSVerification ref="smsValidation"
                               onValidate={()=>this.sendMail()}
                               phoneNumber={this.props.getStore().pharmacy.responsibles[0].phoneNumber}/>
            </form>
          </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Steps/Validation.js